<div class="header">
  <p>{{ config?.header }}</p>
  <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
</div>
<div class="body text-center">
  <div class="title">{{ config.title }}</div>
  <div class="message" [innerHtml]="config.message"></div>

  <div class="mnf-control w-50 mx-auto mb-4">
    <input type="text" class="mnf-input-form otp-input" [ngModel]="otpInput" (ngModelChange)="checkToken($event)" placeholder="• • • • •">
  </div>

  <!-- <div class="d-flex justify-content-around">
    <button mat-button type="button" (click)="checkToken(otpInput)">Confirmar</button>
  </div> -->

</div>
